export const sanitizeUri = (uri) => uri.replace(/\//gu, "");
